import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  AutoCompleteMenu,
  IconedBox,
} from 'views/common/components/UI/MainWidget';
import { PICKUP_LOCATION } from 'views/GeoView/utils/constants';

export const StyledTextField = styled(TextField)(
  ({ theme }) => ({
    '&.GLFTextField': {
      color: theme.palette.common.white,
      '& .MuiInputBase-root': {
        color: theme.palette.common.white,
        paddingRight: theme.spacing(0),
        fontSize: theme.spacing(2),
        '&::before, &::after': {
          borderColor: 'transparent !important',
          borderBottom: 0,
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
          borderBottom: 0,
        },
        '&.Mui-focused:after': {
          borderBottom: 0,
        },
      },
      '& .MuiInputBase-input': {
        padding: theme.spacing(1.5, 2.25, 0.75, 6),
        [theme.breakpoints.down('xl')]: {
          padding: theme.spacing(2, 2.25, 1.5, 5),
        },
        [theme.breakpoints.down('lg')]: {
          padding: theme.spacing(2, 2.25, 1.5, 6),
        },
        '&::placeholder': {
          color: theme.palette.common.white,
          opacity: 1,
        },
      },

    },
  }),
);

const StyledIconedBox = styled(IconedBox)(({ theme, focused }) => ({
  width: '100%',
  '& .IBIcon': {
    transition: 'top .2s',
    left: theme.spacing(3),
    [theme.breakpoints.between('lg', 'xl')]: {
      left: theme.spacing(2),
    },
  },
  '&:hover .IBIcon path,& .IBIcon path': {
    fill: theme.palette.common.white,
  },
  '& .GWSPickupLabel': {
    opacity: focused ? 1 : 0,
    transition: 'opacity .2s',
    left: theme.spacing(5),
    top: theme.spacing(0.9),
    color: theme.palette.grey[300],
    fontSize: theme.typography.pxToRem(12),
  },
  '& .GLFCloseButton': {
    position: 'absolute',
    right: theme.spacing(-1),
    top: '50%',
    transform: 'translateY(-45%)',
    '& svg': {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
}));

export const StyledAutoCompleteMenu = styled(AutoCompleteMenu)(
  ({ theme, useMyLocationHeight, fieldType }) => ({
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider[7]}`,
    background: theme.palette.secondary.dark,
    backdropFilter: `blur(${theme.spacing(1)})`,
    padding: theme.spacing(0.5),
    width: fieldType === PICKUP_LOCATION ? theme.spacing(56) : '100%',
    minWidth: theme.spacing(30),
    [theme.breakpoints.down('xl')]: {
      width: fieldType === PICKUP_LOCATION ? theme.spacing(37) : '100%',
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
    // listbox scroll
    '& .MuiAutocomplete-listbox': {
      maxHeight: theme.spacing(62.25),
      overflowY: 'auto',
      padding: 0,

      /* Scrollbar Styles */
      '&::-webkit-scrollbar': {
        width: theme.spacing(1),
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.grey[700],
        borderRadius: theme.spacing(1),
        border: '2px solid transparent',
        backgroundClip: 'content-box',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.grey[500],
      },
    },
    '&.fullWidth': {
      width: '100%',
    },

    '& .GLFOption': {
      dispaly: 'flex',
      alignItems: 'baseline',
      padding: `${theme.spacing(1.5, 1.5)} !important`,
      border: '1px solid transparent',
      '&:hover, &.Mui-focused': {
        backgroundColor: theme.palette.action.hover,
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette.divider[3]}`,
      },
      '& .GLFOptionTitle': {
        paddingLeft: theme.spacing(1),
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.common.white,
      },
      '& .GLFOptionSubtitle': {
        display: 'block',
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.text.secondary,
      },
      '& .GLFOptionIcon': {
        backgroundColor: theme.palette.divider[5],
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(0.88, 1.5),
        width: theme.spacing(5),
        height: theme.spacing(3.75),
        '& path': {
          fill: theme.palette.common.white,

        },
      },
    },
    '& .GLFOption.GLFUseCurrentOption': {
      background: `${theme.palette.secondary.main} !important`,
      backdropFilter: `blur(${theme.spacing(1)})`,
      zIndex: 1,
      alignItems: 'center',
      '&:hover, &.Mui-focused': {
        border: '0px',
      },

    },
    '& .fixedOption': {
      position: 'absolute',
      background: theme.palette.secondary.main,
      // backdropFilter: `blur(${theme.spacing(1)})`,
      top: theme.spacing(0.08),
      width: '100%',
      height: useMyLocationHeight ? `calc(${useMyLocationHeight - 1}px)` : theme.typography.pxToRem(56),
      '&:hover, &.Mui-focused': {
        border: `1px solid ${theme.palette.divider[3]} !important`,
      },
      '&.GLFOption .GLFOptionIcon path': {
        fill: theme.palette.common.white,
      },
    },
    '& .GLFDropoffOption': {
      padding: `${theme.spacing(1.5)} !important`,
      color: theme.palette.common.white,
      alignItems: 'center',
    },
    '& .GLFOption.GLFPickupDropdown': {
      dispaly: 'flex',
      alignItems: 'start',
    },

  }),
);

export default StyledIconedBox;
